import React, { useState } from 'react';
import { cloneDeep } from 'lodash';

import ItemWithVariant from './ItemWithVariant';
import ItemWithoutVariant from './ItemWithoutVariant';
import ItemNameAndRemoveButton from './ItemNameAndRemoveButton';

const initialItemLink = (menu_item, links, item_link_id) => {
  const comparisonFunc = ele => ele.item_link_id === item_link_id;
  return menu_item.find(comparisonFunc) || links.find(comparisonFunc);
};

const TableRows = ({
  item_link_id,
  links,
  setFieldValue,
  menu_item,
  selectedLinkIds,
  onEdit,
}) => {
  const [itemLink, setItemLink] = useState(() =>
    initialItemLink(menu_item, links, item_link_id),
  );

  if (
    itemLink.variant &&
    Array.isArray(itemLink.variant) &&
    itemLink.variant.length !== 0
  ) {
    const variantAtRootLevel = cloneDeep(itemLink.variant);
    const itemVariants = variantAtRootLevel[0].variants;
    return (
      <>
        <ItemNameAndRemoveButton
          itemLink={itemLink}
          menu_item={menu_item}
          item_link_id={item_link_id}
          setFieldValue={setFieldValue}
          selectedLinkIds={selectedLinkIds}
          onEdit={onEdit}
        />
        {itemVariants.map((itemVariant, itemVariantIndex) => (
          <ItemWithVariant
            key={itemVariant.variant_id}
            variantAtRootLevel={variantAtRootLevel}
            itemVariant={itemVariant}
            itemVariantIndex={itemVariantIndex}
            setItemLink={setItemLink}
          />
        ))}
      </>
    );
  }

  return (
    <ItemWithoutVariant
      setFieldValue={setFieldValue}
      menu_item={menu_item}
      item_link_id={item_link_id}
      setItemLink={setItemLink}
      itemLink={itemLink}
      selectedLinkIds={selectedLinkIds}
      onEdit={onEdit}
    />
  );
};

export default TableRows;
